/* @ngInject */
const editFieldModal = (
  $uibModal,
  $$owner,
  wagonRequest,
  toaster,
  utils
) => {
  const self = {}

  self.open = (_wagon, _fieldName) => {
    return $uibModal.open({
      template: require('./editField.html'),
      resolve: {
        wagon: () => {
          return _wagon
        },
        fieldName: () => {
          return _fieldName
        },
      },
      /* @ngInject */
      controller: (
        $scope,
        $uibModalInstance,
        wagonFields,
        wagon,
        fieldName
      ) => {
        $scope.myWagon = wagon
        $scope.fieldName = fieldName
        $scope.fieldsOptions = wagonFields

        const oldModel = $scope.myWagon[fieldName]

        if ($scope.fieldsOptions[fieldName].type.nature === 'date') {
          $scope.myWagon[fieldName] = utils.date.timestampToString($scope.myWagon[fieldName])
        }

        $scope.submit = async (_fieldName, _fieldValue, _id) => {
          if ($scope.fieldsOptions[fieldName].type.nature === 'date') {
            _fieldValue = utils.date.stringToServer($scope.myWagon[fieldName])
          }

          const data = {
            name: _fieldName,
            value: _fieldValue,
            id: _id,
          }

          try {
            const response = await wagonRequest.updateField(data)

            if ($scope.fieldsOptions[fieldName].type.nature === 'date') {
              $scope.myWagon[fieldName] = +utils.date.stringToTimestamp($scope.myWagon[fieldName])
            }

            $uibModalInstance.close()
          } catch (error) {
            toaster.error(error)
            $scope.myWagon[fieldName] = oldModel
            $uibModalInstance.close()
          }
        }

        $scope.cancel = () => {
          $scope.myWagon[fieldName] = oldModel
          $uibModalInstance.close()
        }
      },
    })
  }

  return self
}
export default editFieldModal



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/modals/editField.modal.js